import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcppicture1getGetScreenTruthLeasesIdEvidenceResponseSchema = jsonObject
export type tcppicture1getGetScreenTruthLeasesIdEvidenceResponse = z.infer<typeof tcppicture1getGetScreenTruthLeasesIdEvidenceResponseSchema>
